<p-card styleClass="card-style-donor">
  <ng-template pTemplate="header">
    <p>Current Cycle</p>
  </ng-template>
  <div class="grid">
    <div class="col-12" *ngIf="donorCurrentCycleDonations === null">
      <p-skeleton width="12rem" styleClass="mb-2" />
      <p-skeleton width="7rem" styleClass="mb-2" />
      <p-skeleton width="7rem" styleClass="mb-5" />
      <p-skeleton width="100%" height="20rem" styleClass="mb-2" />
    </div>
    <div class="col-12" *ngIf="donorCurrentCycleDonations !== null">
      <p><b>Current Cycle Fund Code: </b>{{donorCurrentCycleDonations?.currentFundCode}}</p>
      <p><b>Total: </b>{{ donorCurrentCycleDonations?.total | currency }}</p>
      <p><b>Count: </b>{{ donorCurrentCycleDonations?.count }}</p>
      <p-chart
        type="bar"
        [data]="donorCurrentCycleDonationsChartData"
        [options]="donorCurrentCycleDonationsChartOptions"
        width="100%"
        height="300px"
      ></p-chart>
    </div>
  </div>
</p-card>
